import React, { memo } from "react";

function BotonFavoritoProducto({
  productoId,
  activo = false,
  onToggle,
  size = 34,
  style = {},
}) {
  if (!productoId || !onToggle) {
    return null;
  }

  return (
    <button
      type="button"
      aria-label={activo ? "Quitar de favoritos" : "Agregar a favoritos"}
      title={activo ? "Quitar de favoritos" : "Agregar a favoritos"}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle(productoId);
      }}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "999px",
        border: activo ? "1px solid #ffb3c1" : "1px solid #eee",
        backgroundColor: activo ? "#fff0f3" : "rgba(255,255,255,0.95)",
        color: activo ? "#e00034" : "#555",
        fontSize: size >= 34 ? "18px" : "15px",
        fontWeight: "900",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        lineHeight: 1,
        padding: 0,
        ...style,
      }}
    >
      {activo ? "❤️" : "♡"}
    </button>
  );
}

export default memo(BotonFavoritoProducto);
